module.exports = __webpack_public_path__ + "img/COMBO WAVES PURPLE.0246e0e.svg";